const config = {
  API_BASE_URL: 'https://hotelapi.goerp.live/api',
  LOGIN_API: '/auth/login',
  REGISTER_API: '/auth/register',
  PRODUCT_LIST_API: '/products',
  ORDER_SAVE_API: '/orders/save',
};

export default config;
